import { render, staticRenderFns } from "./payment-form-manage-booking.vue?vue&type=template&id=2ddb0c36&scoped=true"
import script from "./payment-form-manage-booking.vue?vue&type=script&lang=ts"
export * from "./payment-form-manage-booking.vue?vue&type=script&lang=ts"
import style0 from "./payment-form-manage-booking.pcss?vue&type=style&index=0&id=2ddb0c36&prod&lang=postcss&scoped=true&external"
import style1 from "./payment-form-manage-booking.vue?vue&type=style&index=1&id=2ddb0c36&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb0c36",
  null
  
)

export default component.exports